import { useMemo } from 'react'
import { stencil, usePublicTenantSettings, useTenantSettings } from 'react-common'
import { supportedLocales } from '@/plugins/i18n'
import { Locales } from './UserMenuPreset'

/**
 * DO NOT USE IT DIRECTLY!!!
 */

const { useLocaleContext, LOCALE_DEFAULT } = stencil

type Options = {
  /**
   * @default false
   */
  isPublic?: boolean
}
export const useLocale = ({ isPublic = false }: Options = {}) => {
  const useSettings = isPublic ? usePublicTenantSettings : useTenantSettings

  const tenantLocalesStr = useSettings('platform.common.supported_locales')
  const tenantLocales = useMemo(() => {
    if (!tenantLocalesStr) {
      return []
    }
    return tenantLocalesStr.split(',').map((locale) => locale.trim()) as Locales[]
  }, [tenantLocalesStr])

  const tenantLocale = useSettings('platform.common.locale') as Locales

  const { localeMenu, setLocale, currentLocale } = useLocaleContext(
    supportedLocales as Locales[],
    tenantLocales,
    tenantLocale || LOCALE_DEFAULT,
    isPublic,
  )

  return { localeMenu, setLocale, currentLocale }
}
